import { QueryKey } from '@tanstack/react-query';
import Switch from 'components/switch/Switch';
import {
  IntegrationStatus,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import useToggleSwitch from './useToggleSwitch';

const DefaultSwitch = ({
  integrationSetting,
  queryKey,
}: {
  integrationSetting: InternalIntegrationSetting;
  queryKey: QueryKey;
}) => {
  const { handleToggle } = useToggleSwitch({
    integrationSetting,
    queryKey,
  });

  const isActive =
    integrationSetting.agencySettings.status === IntegrationStatus.ACTIVE;

  return (
    <Switch
      data-testid="integration-status-switch"
      className="small"
      checked={isActive}
      onClick={(e) => {
        e.stopPropagation();
        handleToggle();
      }}
    />
  );
};

export default DefaultSwitch;
